import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ShopStatus } from "@/utils/enums.js";
export default {
  name: "MemberOrderRefund",
  props: ["current"],
  data: function data() {
    return {
      showRefundDialog: false,
      selectItem: [],
      refundText: "",
      detail: {},
      tableData: [],
      refundNum: {}
    };
  },
  computed: {
    refundPrice: function refundPrice() {
      var _this = this;

      var sum = 0;

      if (this.current == 6) {
        // this.tableData.forEach(row => {
        //   sum += row.fact_price * this.refundNum[row.id];
        // });
        // sum = sum / 100;
        sum = this.tableData.reduce(function (pre, cur) {
          return pre + _this.getItemRefundPrice(cur);
        }, 0);
      } else {
        this.selectItem.forEach(function (i) {
          sum += Number(i.paid_price);
        });
      }

      return sum;
    }
  },
  methods: {
    getItemRefundPrice: function getItemRefundPrice(item) {
      var refundNum = this.refundNum[item.id] || 0;

      if (item.can_refund_num !== 0 && item.can_refund_num === item.product_number && refundNum === item.product_number) {
        return +item.paid_price;
      }

      return refundNum * +item.fact_price;
    },
    selectable: function selectable(row) {
      if (row.shop_status == 5) {
        return false;
      } else {
        return true;
      }
    },
    applyRefund: function () {
      var _applyRefund = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(item) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.tempOrderId = item.id;
                this.$http.post("/api/app/myOrder/detail", {
                  order_id: item.id
                }).then(function (res) {
                  _this2.detail = res;
                  var refundNum = {};
                  var tableData = res.items;
                  tableData.forEach(function (i) {
                    refundNum[i.id] = 0;
                    i.price = _this2.$pub.calcPrice(i.price);
                    i.discount_price = _this2.$pub.calcPrice(i.discount_price);
                    i.coupon_price = _this2.$pub.calcPrice(i.coupon_price);
                    i.paid_price = _this2.$pub.calcPrice(i.paid_price);
                    i.fact_price = _this2.$pub.calcPrice(i.fact_price);
                    i.shop_status_name = ShopStatus.getValue(i.shop_status);
                  });
                  _this2.tableData = tableData;
                  _this2.showRefundDialog = true;
                  _this2.refundNum = refundNum;
                  _this2.selectItem = [];
                  _this2.refundText = "";
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function applyRefund(_x) {
        return _applyRefund.apply(this, arguments);
      }

      return applyRefund;
    }(),
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectItem = selection;
    },
    handleSubmitRefund: function handleSubmitRefund() {
      var _this3 = this;

      var items = [];

      if (this.current == 6) {
        for (var key in this.refundNum) {
          var num = this.refundNum[key];

          if (num > 0) {
            items.push({
              order_item_id: key,
              refund_num: num
            });
          }
        }
      } else {
        items = this.selectItem.map(function (t) {
          return {
            order_item_id: t.id,
            refund_num: t.product_number || 1
          };
        });
      }

      if (items.length == 0) {
        if (this.current == 6) {
          this.$message.error("请至少选择一个课时");
        } else if (this.current == 4) {
          this.$message.error("请至少选择一个商品");
        } else {
          this.$message.error("请至少选择一门课程");
        }

        return;
      }

      this.$http.get("/api/app/myOrder/application/".concat(this.tempOrderId), {
        items: JSON.stringify(items),
        reason: this.refundText
      }).then(function () {
        _this3.$message.success("操作成功");

        _this3.showRefundDialog = false;
        _this3.selectItem = [];
        _this3.refundText = "";

        _this3.$emit("refund");
      });
    }
  }
};